// dependencies
import { Map } from "immutable";

const initialState = Map({
	emailFieldId: null,
	fieldMap: Map(),
	fieldConnectionStatusFilter: null,
});

export default function fields(state = initialState, action) {
	switch (action.type) {
		case "FIELDS:SET_FIELDS":
			return state.setIn(["fieldMap"], action.fieldMap);

		case "FIELDS:SET_EMAIL_FIELD": {
			return state.setIn(["emailFieldId"], action.emailFieldId);
		}

		case "FIELDS:UPDATE_FIELD_CONNECTION_STATUS_FILTER": {
			return state.setIn(["fieldConnectionStatusFilter"], action.fieldConnectionStatusFilter);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
